import React from 'react';
import { BarChart, Bar, XAxis, Tooltip, ResponsiveContainer, Legend } from 'recharts';

const fmt = (n) => (n ?? 0).toLocaleString('it-IT');

// Colori grafico in tinta con l'app (no rosso acceso / verde fluorescente):
// rosso tenue per TIM, verde-teal dell'accent per NON TIM.
const COL_TIM = '#d9596a';
const COL_NON = '#2a9d8f';

export default function TabPanoramica({ kpi, timeline, periodo, setPeriodo }) {
  const cards = kpi ? [
    { l: 'Caricati', v: kpi.total, s: `${fmt(kpi.pending)} da controllare` },
    { l: 'Da controllare', v: kpi.pending, s: 'in coda agli agenti' },
    { l: 'Controllati', v: kpi.verificati, s: `+${fmt(kpi.incremento_oggi)} oggi` },
    { l: 'TIM', v: kpi.tim, s: `${kpi.pct_tim ?? 0}%` },
    { l: 'NON TIM', v: kpi.non_tim, s: `${kpi.pct_non_tim ?? 0}%` },
    { l: 'Pronti Export', v: kpi.esportabili, s: `${fmt(kpi.esportabili_nuovi)} nuovi` },
    { l: 'Esportati', v: kpi.esportati, s: 'totale' },
  ] : [];
  const data = (timeline || []).map((d) => ({
    giorno: (d.giorno || '').slice(5),
    TIM: d.tim || 0,
    'NON TIM': d.non_tim || 0,
  }));

  return (
    <div>
      <div className="xhub-kpis">
        {cards.map((c) => (
          <div key={c.l} className="card xhub-kpi">
            <div className="xhub-kpi-l">{c.l}</div>
            <div className="xhub-kpi-v">{fmt(c.v)}</div>
            <div className="xhub-kpi-s">{c.s}</div>
          </div>
        ))}
      </div>
      <div className="card">
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>
          <h2 style={{ margin: 0 }}>Andamento controllati — ultimi {periodo} giorni</h2>
          <div className="xhub-seg" style={{ marginLeft: 'auto' }}>
            {[14, 30].map((n) => (
              <button key={n} type="button" className={periodo === n ? 'on' : ''} onClick={() => setPeriodo(n)}>{n}g</button>
            ))}
          </div>
        </div>
        <div style={{ width: '100%', height: 240 }}>
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data}>
              <XAxis dataKey="giorno" tick={{ fontSize: 11 }} />
              <Tooltip cursor={{ fill: 'rgba(0, 0, 0, 0.04)' }} />
              <Legend />
              <Bar dataKey="TIM" stackId="a" fill={COL_TIM} />
              <Bar dataKey="NON TIM" stackId="a" fill={COL_NON} radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
